import React from 'react';

function AgeVerification({ onConfirm }) {
  return (
    <div className="fixed inset-0 bg-dark-bg z-50 flex items-center justify-center p-5">
      <div className="max-w-md w-full">
        <div className="bg-gradient-to-br from-dark-card to-dark-surface border border-dark-border rounded-3xl p-8 md:p-10 shadow-2xl text-center">
          {/* Warning Icon */}
          <div className="mb-6 flex justify-center">
            <div className="w-16 h-16 rounded-full bg-red-500/20 border-2 border-red-500/50 flex items-center justify-center">
              <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-2xl md:text-3xl font-bold text-white mb-4">Age Verification Required</h1>
          
          {/* Message */}
          <p className="text-white/70 text-base mb-8 leading-relaxed">
            This website contains mature content. You must be 18 years or older to continue.
          </p>

          {/* Continue Button */}
          <button
            onClick={onConfirm}
            className="w-full py-3.5 px-6 rounded-xl font-semibold text-base transition-all duration-200 bg-accent-blue text-white hover:bg-accent-blue/90 shadow-lg shadow-accent-blue/20 mb-4"
          >
            I am 18 or older, continue
          </button>

          {/* Exit Option */}
          <p className="text-white/40 text-sm">
            If you are under 18, please exit this website.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AgeVerification;

